const LANG = {
	fr: { code: 'fr', id: 1, label: 'french', icon: '/images/fr.png' },
	en: { code: 'en', id: 2, label: 'english', icon: '/images/en.png' },
}

export default LANG
export const FRENCH_NATIONALITY = 285
